<template>
  <div class="page-wrapper">
    <div v-if="isMobile==false" class="container logo-container">
      <div class="row">
        <div class="col-12">
          <img src="@/assets/images/logo.gif"/>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row nav-container">
        <ul>
          <li><a href="#/home/">메인</a></li>
          <li><a href="#/history/">기록</a></li>
          <li><a class="active" href="#/mypage/">마이페이지</a></li>
          <li>
            <i class="fas fa-sign-out-alt logout-btn" v-on:click="logout"></i>
          </li>
        </ul>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-4">
          <div class="card">
            <div class="card-header">
              User Info
            </div>
            <div class="card-body">
              <div class="container">
                <div class="row">
                  <label class="col-4 form-control">Email</label>
                  <input class="col-8 form-control bottom-border" v-model="user.contact_email" disabled/>
                </div>
                <div class="row">
                  <label class="col-4 form-control">User Name</label>
                  <input class="col-8 form-control bottom-border" v-model="user.user_name" disabled/>
                </div>

                <div class="row">
                  <label class="col-4 form-control">Code</label>
                  <input class="col-8 form-control bottom-border" v-model="user.code" disabled/>
                </div>
                <div class="row">
                  <label class="col-4 form-control">Password</label>
                  <input type="password" class="col-8 form-control bottom-border" v-model="password"/>
                </div>
                <div class="row">
                  <label class="col-4 form-control">Confirm</label>
                  <input type="password" class="col-8 form-control bottom-border" v-model="passwordConfirm"/>
                </div>
                <div class="row">
                  <label class="col-4 form-control"> </label>
                  <div class="col-8 text-right" v-if="password.length > 0 && password == passwordConfirm">
                    <i class="fa fa-save border-btn" v-on:click="updatePassword"> Save</i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-4">
          <div class="card">
            <div class="card-header">
              <div class="container">
                <div class="row">
                  <div class="col-6">
                    Business Info
                  </div>
                  <div class="col-6 text-right" style="display:none;">
                    <i v-show="editBusinessInfo==false" class="fa fa-edit" v-on:click="toggleBusinessInfoEdit"> 수정</i>
                    <i class="fa fa-close" v-show="editBusinessInfo==true" v-on:click="toggleBusinessInfoEdit"> 취소</i>
                    <i class="fa fa-save" v-show="editBusinessInfo==true"> 저장</i>
                  </div>
                </div>
              </div>


            </div>
            <div class="card-body">
              <div class="container">
                <div class="row">
                  <label class="col-6 form-control">Business</label>
                  <input class="col-6 form-control bottom-border" v-model="user.title" disabled/>
                </div>
                <div class="row">
                  <label class="col-6 form-control">Address</label>
                  <input class="col-6 form-control bottom-border" v-model="user.address_1" :disabled="editBusinessInfo==false"/>
                </div>
                <div class="row">
                  <label class="col-6 form-control"> </label>
                  <input class="col-6 form-control bottom-border" v-model="user.address_2" :disabled="editBusinessInfo==false"/>
                </div>
                <div class="row">
                  <label class="col-6 form-control"> </label>
                  <input class="col-6 form-control bottom-border" v-model="user.address_3" :disabled="editBusinessInfo==false"/>
                </div>
                <div class="row">
                  <label class="col-6 form-control">Post Code</label>
                  <input class="col-6 form-control bottom-border" v-model="user.post_code" :disabled="editBusinessInfo==false"/>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-4">
          <div class="card">
            <div class="card-header">
              <div class="container">
                <div class="row">
                  <div class="col-6">
                    Contact
                  </div>
                  <div class="col-6 text-right" style="display:none;">
                    <i v-show="editContact==false" class="fa fa-edit" v-on:click="toggleContactInfoEdit"> 수정</i>
                    <i class="fa fa-close" v-show="editContact==true" v-on:click="toggleContactInfoEdit"> 취소</i>
                    <i class="fa fa-save" v-show="editContact==true"> 저장</i>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="container">
                <div class="row">
                  <label class="col-6 form-control">Mobile</label>
                  <input class="col-6 form-control bottom-border" v-model="user.contact_mobile" :disabled="editContact == false"/>
                </div>
                <div class="row">
                  <label class="col-6 form-control">Tel</label>
                  <input class="col-6 form-control bottom-border" v-model="user.contact_tel" :disabled="editContact == false"/>
                </div>
                <div class="row">
                  <label class="col-6 form-control">FAX</label>
                  <input class="col-6 form-control bottom-border" v-model="user.contact_fax" :disabled="editContact == false"/>
                </div>

              </div>
            </div>
          </div>
        </div>


        <div class="col-12 col-md-4">
          <div class="card">
            <div class="card-header">
              <div class="container">
                <div class="row">
                  <div class="col-6">
                    통관관련
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="container">
                <div class="row">
                  <label class="col-6 form-control">관부가세납부</label>
                  <div class="col-3 form-control" v-bind:class="{'setting-selected': user.who_pays_tax==1}" v-on:click="setSenderPayTax(1)">
                    수취인
                  </div>
                  <div class="col-3 form-control" v-bind:class="{'setting-selected': user.who_pays_tax==2}" v-on:click="setSenderPayTax(2)">
                    발신인
                  </div>

                </div>

                <div class="row">
                  <label class="col-6 form-control">통관비</label>
                  <div class="col-3 form-control" v-bind:class="{'setting-selected': user.who_pays_inspection==1}" v-on:click="setSenderPayHandlingCharge(1)">
                    수취인
                  </div>
                  <div class="col-3 form-control" v-bind:class="{'setting-selected': user.who_pays_inspection==2}" v-on:click="setSenderPayHandlingCharge(2)">
                    발신인
                  </div>

                </div>
                <div class="row">
                  <label class="col-6 form-control">Tel</label>
                  <input class="col-6 form-control bottom-border" v-model="user.contact_tel" :disabled="editContact == false"/>
                </div>
                <div class="row">
                  <label class="col-6 form-control">FAX</label>
                  <input class="col-6 form-control bottom-border" v-model="user.contact_fax" :disabled="editContact == false"/>
                </div>

              </div>
            </div>
          </div>
        </div>



        <div class="col-12 col-md-8">
          <div class="card">
            <div class="card-header">
              <div class="container">
                <div class="row">
                  <div class="col-6">
                    Search Word
                  </div>
                  <div class="col-6">
                    <span v-on:click="saveSearchList"><i class="fa fa-save"></i> 저장</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body" v-if="searchList.length > 0" v-bind:class="{'card-body-mobile': isMobile == true}">
              <div class="container">
                <div class="row" v-for="(word, index) in searchList">
                  <div class="col-3"><label class="form-control">검색어 {{index+1}}</label>
                  </div>
                  <div class="col-7">
                    <input class="form-control" type="text" v-model="searchList[index]"/>
                  </div>
                  <div class="col-2">
                    <i class="fa fa-eye" v-on:click="openNaverSearch(index)"></i>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>



        <div class="col-12 col-md-4" v-if="user.id > 0">
          <h1>Signature</h1>
          <div class="image-drop-container">
            <ImageInput ref="pictureInput"
                        @change="onItemImageSelected"
                        v-bind:id="user.id"
                        margin="0"
                        accept="image/jpeg"
                        size="10"
                        prefill="/static/img/image.jpg"
                        :crop="false"
                        :key="user.id"
                        v-bind:imageUrl="user.signature_url"
                        buttonClass="image-input-button"
            ></ImageInput>
          </div>
        </div>

        <div class="col-12 col-md-4" v-if="user.id > 0">
          <h1>Logo</h1>
          <div class="image-drop-container">
            <ImageInput ref="pictureInput"
                        @change="onLogoImageSelected"
                        v-bind:id="user.id + '-logo'"
                        margin="0"
                        accept="image/jpeg, image/png"
                        size="10"
                        prefill="/static/img/image.jpg"
                        :crop="false"
                        :key="user.id + '-logo'"
                        v-bind:imageUrl="user.logo_url"
                        buttonClass="image-input-button"
            ></ImageInput>
          </div>
        </div>
      </div>
    </div>
    <div class="spinner-container" v-if="isLoading">
      <div class="spinnermedium">
        <span class="bgtopl"><span class="highlighttopl"></span></span>
        <span class="bgtopr"><span class="highlighttopr"></span></span>
        <span class="bottomrow">
          <span class="bgbtml"><span class="highlightbtml"></span></span>
          <span class="bgbtmr"><span class="highlightbtmr"></span></span>
        </span>
      </div>
    </div>
    <v-dialog/>
  </div>
</template>

<script>
    import {getCustomerInfo, updateCustomerInfo, priceComparisonReport, priceComparisonReportEmail} from "../api/customer";
    import {getDepotCode} from "../api/parcel";
    import {updateAPI} from "../api/general";
    import ImageInput from "./ImageInput";
    import AWS from 'aws-sdk';
    import moment from 'moment';
    import Router from '../router';
    export default {
        name: "MyPage",
        data() {
            return {
                user: {
                    id: 0,
                },
                password:'',
                passwordConfirm:'',
                editBusinessInfo:false,
                editContact:false,
                searchList:[],

                isLoading:false,
                isMobile: false,
            }
        },
        components: {
           ImageInput
        },
        created() {
            this.$data.isMobile = isFromMobile();
            this.$data.user.id = localStorage.getItem('id');
            this.getCustomerData(this.$data.user.id);
        },
        mounted() {
        },
        methods: {
            showModal: function (title, message) {
                console.log("show modal " + title + " : " + message);
                this.$modal.show('dialog', {
                    title: title,
                    text: message,
                    buttons: [
                        {title: 'Close'}
                    ]
                })
                return;
            },
            logout: function () {
                let self = this;
                this.$modal.show('dialog', {
                    //title: '로그아웃',
                    text: '로그아웃 하시겠습니까?',
                    buttons: [
                        {
                            title: '아니요',
                            handler: () => {
                                self.$modal.hide('dialog');

                            }
                        },
                        {
                            title: '로그아웃',
                            handler: () => {
                                self.$modal.hide('dialog');
                                self.onLogoutConfirmed();
                            }
                        },

                    ]

                });
            },
            onLogoutConfirmed: function () {
                localStorage.removeItem('id');
                localStorage.removeItem('email');
                localStorage.removeItem('level');
                localStorage.removeItem('admin');
                localStorage.removeItem('password');
                Router.push('/');
            },
            addSearchList: function() {
                console.log("addSearchList");
                if(this.$data.searchList.length < 5) {
                    for (let i = this.$data.searchList.length; i < 5; i++) {
                        this.$data.searchList.push("");
                    }
                }
                console.log(this.$data.searchList);

            },
            getCustomerData: function(id) {
                let self = this;
                getCustomerInfo(id)
                    .then(function(data){
                        console.log(data);
                        if(data.success == true) {
                            self.$data.user = data.item;
                            console.log("USER");
                            console.log(self.$data.user);
                            if(data.item.search_list.length > 0) {
                                console.log("search list length = " + data.item.search_list.length)
                                self.$data.searchList = data.item.search_list.split(",");
                            } else {
                                self.$data.searchList = ["","","","",""];
                            }
                            self.addSearchList();


                        }
                    })
                    .catch(function(err){

                    })
            },
            toggleBusinessInfoEdit: function() {
                this.$data.editBusinessInfo = !this.$data.editBusinessInfo;
                if(this.$data.editBusinessInfo == false) {
                    this.getCustomerData(this.$data.user.id);
                }
            },
            toggleContactInfoEdit: function() {
                this.$data.editContact = !this.$data.editContact;
                if(this.$data.editContact == false) {
                    this.getCustomerData(this.$data.user.id);
                }
            },
            updatePassword: function() {
                if(this.$data.password !== this.$data.passwordConfirm) {
                    return;
                }

                let data  = {
                    id: this.user.id,
                    password:this.$data.password,
                };
                let postData = {
                    table: "customer_table",
                    data:data,
                };
                let self = this;
                updateAPI(postData)
                    .then(function(data){
                        if(data.success == true) {
                            self.$data.user = data.item;
                            self.showModal("", "비밀번호가 변경되었습니다.")
                            if(data.item.search_list.length > 0) {
                                self.$data.searchList = data.item.search_list.split(",");
                            } else {
                                self.$data.searchList = ["","","","",""];

                            }
                            self.addSearchList();
                        } else {
                            console.log("Error to update signature image");

                        }
                    })
                    .catch(function(err){
                        console.log(err.response);
                    });

            },
            saveSearchList: function() {
                let searchList =  this.$data.searchList.join(',');
                let data  = {
                    id: this.$data.user.id,
                    search_list:searchList,
                };
                let postData = {
                    table: "customer_table",
                    data:data,
                };
                let self = this;
                updateAPI(postData)
                    .then(function(data){
                        if(data.success == true) {
                            self.$data.user = data.item;
                            if(data.item.search_list.length > 0) {
                                self.$data.searchList = data.item.search_list.split(",");
                            } else {
                                self.$data.searchList = ["","","","",""];

                            }
                            self.addSearchList();
                        } else {
                            console.log("Error to update signature image");

                        }
                    })
                    .catch(function(err){
                        console.log(err.response);
                    });
            },
            submitUserData: function() {

            },
            test: function() {
                console.log("test")
                getDepotCode().then(function(data){
                    console.log("Test result");
                    console.log(data);
                })
            },
            onLogoImageSelected: function({image, index}) {
                console.log('New picture selected!');
                let self = this;

                //return;
                if (image) {
                    var i = new Image();
                    i.onload = function() {
                        var imgW = i.width;
                        var imgH = i.height;

                        var proportion = 1.0;
                        if(imgH > imgW) {
                            proportion = 300/imgH;
                        } else {
                            proportion = 300/imgW;
                        }

                        var canvas = document.createElement('canvas');
                        var ctx = canvas.getContext('2d');

                        // set its dimension to target size
                        canvas.width = imgW*proportion;
                        canvas.height = imgH*proportion;

                        // draw source image into the off-screen canvas:
                        ctx.drawImage(this, 0, 0, canvas.width, canvas.height);

                        // encode image to data-uri with base64 version of compressed image
                        //return canvas.toDataURL();
                        console.log(canvas);
                        var bob = canvas.toDataURL();
                        console.log('Picture loaded.');
                        console.log(bob);

                        /**
                         * Perform upload image
                         * and update db
                         */
                        self.uploadLogoImage(bob, index);
                    }
                    i.src = image;

                    // this.uploadImage(this.image);
                } else {
                    console.log('FileReader API not supported: use the <form>, Luke!')
                }
            },
            uploadLogoImage: function(image, id) {
                let d = new Date();
                let name  =  moment(d).format('YYYYMMDD-hhmmss');

                let path = 'customer/logo-' + name + '.png';
                if(path == false) {
                    return;
                }
                //var path = this.$data.menus[index].id + '/' + name + '.jpg';
                console.log("Path: " + path + " type:");
                //return;
                AWS.config.update({
                  "accessKeyId" : "AKIAVFA3UHM636OYWHDE",
                  "secretAccessKey" : "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",
                  "region" : "eu-west-2"
                });

                let block = image.split(";");
                // Get the content type of the image
                let contentType = block[0].split(":")[1];// In this case "image/gif"
                // get the real base64 content of the file
                let realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."

                // Convert it to a blob to upload
                let blob = this.b64toBlob(realData, contentType);

                // Create a FormData and append the file with "image" as parameter name
                //var formDataToUpload = new FormData(form);
                let s3 = new AWS.S3();
                let params = {
                    Bucket: 'utasco',
                    Key: path,
                    ContentType: contentType,
                    Body : blob,
                    ACL: 'public-read'
                };
                //return;
                let self = this;

                // Now upload to S3
                s3.putObject(params, function(err, res){
                    if(err) {
                        //Error
                        console.log("ERROR to upload " + err);

                    } else {
                        //On success, update item
                        console.log("Success to upload" + res);
                        console.log(res);
                        self.user.signature = 'https://utasco.s3.eu-west-2.amazonaws.com/' + path;
                        let data  = {
                            id: self.$data.user.id,
                            logo_url: self.$data.user.signature,
                        };
                        let postData = {
                            table: "customer_table",
                            data:data,
                        };

                        updateAPI(postData)
                            .then(function(data){
                                if(data.success == true) {
                                    self.$data.user = data.item;
                                } else {
                                    console.log("Error to update signature image");

                                }
                            })
                            .catch(function(err){
                                console.log(err);
                                console.log(err.response);
                            });
                    }
                });
            },
            onItemImageSelected: function({image, index}) {
                console.log('New picture selected!');
                let self = this;

                //return;
                if (image) {
                    var i = new Image();
                    i.onload = function() {
                        var imgW = i.width;
                        var imgH = i.height;

                        var proportion = 1.0;
                        if(imgH > imgW) {
                            proportion = 512/imgH;
                        } else {
                            proportion = 512/imgW;
                        }

                        var canvas = document.createElement('canvas');
                        var ctx = canvas.getContext('2d');

                        // set its dimension to target size
                        canvas.width = imgW*proportion;
                        canvas.height = imgH*proportion;

                        // draw source image into the off-screen canvas:
                        ctx.drawImage(this, 0, 0, canvas.width, canvas.height);

                        // encode image to data-uri with base64 version of compressed image
                        //return canvas.toDataURL();
                        console.log(canvas);
                        var bob = canvas.toDataURL();
                        console.log('Picture loaded.');
                        console.log(bob);

                        /**
                         * Perform upload image
                         * and update db
                         */
                        self.uploadImage(bob, index);
                    }
                    i.src = image;

                    // this.uploadImage(this.image);
                } else {
                    console.log('FileReader API not supported: use the <form>, Luke!')
                }
            },
            uploadImage: function(image, id) {
                let d = new Date();
                let name  =  moment(d).format('YYYYMMDD-hhmmss');

                let path = 'customer/signature-' + name + '.jpg';
                if(path == false) {
                    return;
                }
                //var path = this.$data.menus[index].id + '/' + name + '.jpg';
                console.log("Path: " + path + " type:");
                //return;
                AWS.config.update({
                  "accessKeyId" : "AKIAVFA3UHM636OYWHDE",
                  "secretAccessKey" : "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",
                  "region" : "eu-west-2"
                });

                let block = image.split(";");
                // Get the content type of the image
                let contentType = block[0].split(":")[1];// In this case "image/gif"
                // get the real base64 content of the file
                let realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."

                // Convert it to a blob to upload
                let blob = this.b64toBlob(realData, contentType);

                // Create a FormData and append the file with "image" as parameter name
                //var formDataToUpload = new FormData(form);
                let s3 = new AWS.S3();
                let params = {
                    Bucket: 'utasco',
                    Key: path,
                    ContentType: contentType,
                    Body : blob,
                    ACL: 'public-read'
                };
                //return;
                let self = this;

                // Now upload to S3
                s3.putObject(params, function(err, res){
                    if(err) {
                        //Error
                        console.log("ERROR to upload " + err);

                    } else {
                        //On success, update item
                        console.log("Success to upload" + res);
                        console.log(res);
                        self.user.signature = 'https://utasco.s3.eu-west-2.amazonaws.com/' + path;
                        let data  = {
                            id: self.$data.user.id,
                            signature_url: self.$data.user.signature,
                        };
                        let postData = {
                            table: "customer_table",
                            data:data,
                        };

                        updateAPI(postData)
                            .then(function(data){
                                if(data.success == true) {
                                    self.$data.user = data.item;
                                } else {
                                    console.log("Error to update signature image");

                                }
                            })
                            .catch(function(err){
                                console.log(err);
                                console.log(err.response);
                            });
                    }
                });
            },
            b64toBlob: function(b64Data, contentType, sliceSize) {
                contentType = contentType || '';
                sliceSize = sliceSize || 512;

                var byteCharacters = atob(b64Data);
                var byteArrays = [];

                for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    var slice = byteCharacters.slice(offset, offset + sliceSize);

                    var byteNumbers = new Array(slice.length);
                    for (var i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    var byteArray = new Uint8Array(byteNumbers);

                    byteArrays.push(byteArray);
                }

                var blob = new Blob(byteArrays, {type: contentType});
                return blob;
            },
            openNaverSearch: function(index) {
                let word = this.$data.searchList[index];
                console.log("Search " + word);
                let data = {
                    text: word,
                    to: this.$data.user.contact_email,
                };
                console.log("openNaverSearch");
                console.log(data);
                let self = this;
                this.$data.isLoading = true;
                priceComparisonReport(data)
                    .then(function(response) {
                        self.$data.isLoading = false;
                        console.log("priceComparisonReport Response");
                        console.log(response);
                        self.showModal("Completed", "Please check email " + self.$data.user.contact_email);
                    })
                    .catch(function(err) {
                        self.$data.isLoading = false;
                        console.log(err);
                        console.log(err.response);
                        self.showModal("Failed", "Error happened " + err);
                    })
                //window.open(process.env.APP_URL + 'api/search_naver.php?text=' + word, "_blank");
            },
            openNaverSearchEmail: function(index) {
                let word = this.$data.searchList[index];
                console.log("Search " + word);
                let data = {
                    text: word,
                    to: this.$data.user.contact_email,
                };
                console.log("openNaverSearch");
                console.log(data);
                priceComparisonReportEmail(data)
                    .then(function(response) {
                        console.log("priceComparisonReport Response");
                        console.log(response);
                    })
                    .catch(function(err) {
                        console.log(err);
                        console.log(err.response);
                    })
            },
            setSenderPayTax: function(val) {
                let data  = {
                    id: this.$data.user.id,
                    who_pays_tax: val,
                };
                let postData = {
                    table: "customer_table",
                    data:data,
                };

                let self = this;
                updateAPI(postData)
                    .then(function(data){
                        if(data.success == true) {
                            console.log("user updated successfully");
                            self.$data.user = data.item;
                        } else {
                            console.log("Error to update signature image");

                        }
                    })
                    .catch(function(err){
                        console.log(err);
                        console.log(err.response);
                    });
            },
            setSenderPayHandlingCharge: function(val) {
                let data  = {
                    id: this.$data.user.id,
                    who_pays_inspection: val,
                };
                let postData = {
                    table: "customer_table",
                    data:data,
                };

                let self = this;
                updateAPI(postData)
                    .then(function(data){
                        if(data.success == true) {
                            console.log("user updated successfully");
                            self.$data.user = data.item;
                        } else {
                            console.log("Error to update signature image");

                        }
                    })
                    .catch(function(err){
                        console.log(err);
                        console.log(err.response);
                    });
            }
        }
    }
</script>

<style scoped>
  .bottom-border {
    border-top: none;
    border-left: none;
    border-right: none;
    border-radius: 0px;
  }
  .card-body {
    padding: 1.25rem;
  }
  .border-btn {
    border:1px solid black;
    padding:5px;
    font-size: 20px;

  }
  i {
    cursor: pointer;
  }
  .card-body-mobile {
    padding-left: 0px;
    padding-right: 0px;
  }
  .setting-selected {
    background: blue;
    color:white;
  }
  .image-drop-container {
    width:300px;
    height:300px;
    margin-left: auto;
    margin-right:auto;
    border:1px solid black;
  }
</style>



// WEBPACK FOOTER //
// src/components/MyPage.vue